var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { convertToClientCountryData, convertToServerCountryData } from '@core';
import { convertToClientMaterialOriginTypeData, convertToServerMaterialOriginTypeData, } from './material-origin-type.converter';
import { convertToClientMaterialTypeData, convertToServerMaterialTypeData, } from './material-type.converter';
export var convertToServerMaterialsFilterData = function (data) { return ({
    name: data.name || null,
    materialType: convertToServerMaterialTypeData(data.materialType) || null,
    density: data.density ? +data.density : null,
    thickness: data.thickness ? +data.thickness : null,
}); };
export var convertToClientMaterialsAddAndEditData = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    return ({
        id: (_a = data.id) !== null && _a !== void 0 ? _a : '',
        name: (_b = data.name) !== null && _b !== void 0 ? _b : '',
        description: (_c = data.description) !== null && _c !== void 0 ? _c : '',
        shortName: (_d = data.shortName) !== null && _d !== void 0 ? _d : '',
        density: (_e = String(data.density)) !== null && _e !== void 0 ? _e : '',
        thickness: (_f = String(data.thickness)) !== null && _f !== void 0 ? _f : '',
        type: (_g = convertToClientMaterialOriginTypeData(data.type)) !== null && _g !== void 0 ? _g : [],
        country: (_h = convertToClientCountryData(data.countries)) !== null && _h !== void 0 ? _h : '',
        issuer: (_k = (_j = data.issuer) === null || _j === void 0 ? void 0 : _j.id) !== null && _k !== void 0 ? _k : '',
        imageUrl: (_l = data.imageUrl) !== null && _l !== void 0 ? _l : '',
        materialCoefficient: (_m = String(data.materialCoefficient)) !== null && _m !== void 0 ? _m : '',
        materialType: (_o = convertToClientMaterialTypeData(data.materialType)) !== null && _o !== void 0 ? _o : '',
        velocity: (_p = String(data.velocity)) !== null && _p !== void 0 ? _p : '',
        lossFactor: (_q = String(data.lossFactor)) !== null && _q !== void 0 ? _q : '',
        youngModulus: (_r = String(data.youngModulus)) !== null && _r !== void 0 ? _r : '',
        damping: (_s = String(data.damping)) !== null && _s !== void 0 ? _s : '',
        solid: (_t = String(data.solid)) !== null && _t !== void 0 ? _t : '',
    });
};
export var convertToServerMaterialsAddData = function (data) { return ({
    id: data.id || null,
    name: data.name || null,
    description: data.description || null,
    shortName: data.shortName || null,
    density: +data.density || null,
    thickness: +data.thickness || null,
    type: convertToServerMaterialOriginTypeData(data.type) || null,
    countryTypes: convertToServerCountryData(data.country) || null,
    issuerId: data.issuer || null,
    formFile: data.imageFile,
    materialCoefficient: +data.materialCoefficient || null,
    materialTypeEnum: data.materialType || null,
    velocity: +data.velocity || null,
    lossFactor: +data.lossFactor || null,
    youngModulus: +data.youngModulus || null,
    damping: +data.damping || null,
    solid: +data.solid || null,
}); };
export var convertToServerMaterialsEditData = function (data) { return (__assign(__assign({}, convertToServerMaterialsAddData(data)), { countries: convertToServerCountryData(data.country) || null })); };
